import { Megaphone } from "lucide-react";
import { createIcon } from "@/components/icons/create-icon";

export const MegaphoneIcon = createIcon(Megaphone);
